<div class="app-content vertical-scroll" cdkScrollable>
    <ssg-prenote-history-table></ssg-prenote-history-table>
</div>
